import http from '@core/fetch'
import { API_SHOP_INFO } from '@constant'

export default {
  getListApi: body =>
    http('/p/wedding/index.php/Admin/APIMerchantServer/list', { body }),

  getDetailApi: body =>
    http('/p/wedding/index.php/Admin/APIMerchantServer/detail', { body }),

  fee: body =>
    http.post('/p/wedding/index.php/admin/APIMerchantPro/pay_money', { body }),

  getLiteAppStatus: () => http('/p/wedding/Admin/APIMerchantWeapp/Info'),

  getInfo: () => http(API_SHOP_INFO),

  getSubMerchantStatus: () =>
    http('/p/wedding/index.php/Admin/APIMerchant/upgrade_status'),

  /* 店铺店铺服务（收费）视频 */
  getProVideo: () =>
    http('/p/wedding/index.php/Admin/APIMerchantServer/pro_promotion_vedio'),

  /* 商家店铺服务（收费）详情 */
  getProData: () => http('/p/wedding/index.php/Admin/APIMerchant/buyProInfo')
}
